import React, { useState } from 'react';  
import { NavLink } from 'react-router-dom';  
import '../Style/Sidebar.css';  
import { FaBars, FaUser, FaHome, FaBlogger } from 'react-icons/fa';  
import { MdDashboard, MdOutlineHomeWork, MdContactSupport } from 'react-icons/md';  
import { GrGallery } from 'react-icons/gr';  
import { FaCircleArrowRight } from "react-icons/fa6";
import { FaCircleArrowLeft } from "react-icons/fa6";

function Sidebar() {  
  const menuBar = [  
    { icon: <MdDashboard />, name: 'Dashboard', path: '/dashboard' },  
    { icon: <FaHome />, name: 'Home', path: '/home' },  
    { icon: <FaUser />, name: 'About', path: '/about' },  
    { icon: <MdOutlineHomeWork />, name: 'Properties', path: '/properties' },  
    { icon: <GrGallery />, name: 'Gallery', path: '/gallery' },  
    { icon: <MdContactSupport />, name: 'Contact', path: '/contact' },  
    { icon: <FaBlogger />, name: 'Blog', path: '/blog' },  
  ];  

  const [isOpen, setIsOpen] = useState(false);  

  const toggleSidebar = () => {  
    setIsOpen(!isOpen);  
  };  

  return (  
    <div className='side-container'>  
      <div  
        style={{ width: isOpen ? '240px' : '80px'}}  
        className='nav min-h-screen bg-green-500 text-white w-60 py-[100px] border-r-4 border-gray-700'  
      >  
        { isOpen ? <div className='bar px-4 py-2 ml-3'>  
          <FaCircleArrowLeft onClick={toggleSidebar} className='text-2xl cursor-pointer' />  
          </div> : <div className='bar px-4 py-2 ml-3'>  
          <FaCircleArrowRight onClick={toggleSidebar} className='text-2xl cursor-pointer' />  
        </div> 
        } 

        {menuBar.map((item, index) => (  
          <NavLink  
            key={index}  
            className={isOpen ? 'normal' : 'toggle'}  
            activeClassName='active'  
            to={item.path}  
          >  
            <div className='flex items-center'>  
              <div className='text-2xl'>{item.icon}</div>  
              <h1 className='ml-2' style={{ display: isOpen ? 'block' : 'none' }}>  
                {item.name}  
              </h1>  
            </div>  
          </NavLink>  
        ))}  
      </div>  
    </div>  
  );  
}  

export default Sidebar;